import { Loader2 } from "lucide-react";

export const Loading = ({ text = "Loading..." }) => (
  <div className="flex min-h-[50vh] items-center justify-center gap-3 text-lg text-[#5C4A3E]" data-testid="loading-indicator">
    <Loader2 className="animate-spin text-[#A83232]" size={28} /> {text}
  </div>
);

export const MockBadge = ({ children = "Simulated", testid }) => (
  <span className="badge-mock" data-testid={testid || "mock-badge"}>MOCK · {children}</span>
);
